var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.$root.mainWrapper},[_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"header"}}),_c('router-view',{key:_vm.$route.fullPath}),_c('router-view',{attrs:{"name":"footer"}})],1),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"bottomNav"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }